import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate, useParams } from 'react-router-dom';
import { ReloadProvider, useReload } from '../../../contexts/ReloadContext.jsx';
import { useT } from '../../../contexts/LocaleContext.jsx';
import ImportSonglistModal from '../modal/ImportSongListModal.jsx';

import '../../../styles/partial/layout/BandLayoutPage.css';
import TopPageNavigationBand from '../../TopPageNavigationBand.jsx';

import '../../../App.css'
import '../../../styles/partial/modal/modal.css'

const BandLayoutPage = ({ children, previousPage, navigation, showHamburgerMenu = true, pageType = 'default' }) => {
  return (
    <ReloadProvider>
      <BandLayoutPageContent children={children} previousPage={previousPage} navigation={navigation} showHamburgerMenu={showHamburgerMenu} pageType={pageType} />
    </ReloadProvider>
  );
};

const BandLayoutPageContent = ({ children, previousPage, navigation, showHamburgerMenu = true, pageType = 'default' }) => {
  const navigate = useNavigate();
  const { bandid } = useParams();
  const { reloadKey, reload } = useReload();
  const t = useT();
  const [isImportSonglistModalOpen, setIsImportSonglistModalOpen] = useState(false);

  const renderWithReloadKey = (node, extraProps = {}) => (
    React.Children.map(node, child => (
      React.isValidElement(child) ? React.cloneElement(child, { reloadKey, ...extraProps }) : child
    ))
  );

  // Add class to body to override global centering
  useEffect(() => {
    document.body.classList.add('band-page-body');
    return () => {
      document.body.classList.remove('band-page-body');
    };
  }, []);

  if (bandid && previousPage) {
    // Modify the previousPage URL to include the ID
    previousPage = previousPage.replace(':bandid', bandid);
  }

  const handleImportSonglist = () => {
    setIsImportSonglistModalOpen(true);
  };

  const handleAddEvent = () => {
    // Trigger add event action by dispatching a custom event
    const event = new CustomEvent('addEventTriggered');
    window.dispatchEvent(event);
  };

  const handleCloseImportModal = () => {
    setIsImportSonglistModalOpen(false);
    // Trigger reload after modal closes
    if (reload) {
      reload();
    }
  };

  return (
    <div className="performer-page">
      <TopPageNavigationBand showHamburgerMenu={showHamburgerMenu} onImportSonglist={handleImportSonglist} pageType={pageType} onAddEvent={handleAddEvent} />
      <div className={`performer-page-wrapper${pageType !== 'default' ? ` performer-page-wrapper--${pageType}` : ''}`}>
        <div className={`performer-page-content${pageType !== 'default' ? ` performer-page-content--${pageType}` : ''}`}>
          <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            {previousPage && (
              <div className="back-arrow" role="button" aria-label={t('common.actions.back')} tabIndex={0} onClick={() => navigate(previousPage)} onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate(previousPage)}>
                <FaArrowLeft className="rtl-mirror" /> {t('common.actions.back')}
              </div>
            )}
            {renderWithReloadKey(children)}
          </div>
        </div>

        {navigation && (
          <div className="performer-page-right-side-navigation">
            {renderWithReloadKey(navigation, { onImportSonglist: handleImportSonglist })}
          </div>
        )}
      </div>
      <ImportSonglistModal isOpen={isImportSonglistModalOpen} onClose={handleCloseImportModal} />
    </div>
  );
};

export default BandLayoutPage;